import { SPACING } from "@joonapp/web-shared"
import React, { CSSProperties, useRef } from "react"

import useMobile from "../../hooks/useMobile"

type Props = {
  children: React.ReactNode
  isOpen: boolean
  onClose: () => void
  showCard: boolean
  size: "fit-content" | "default" | "full-height"
  desktopWidth: CSSProperties["width"]
}

const SlideUpModalCard = ({
  isOpen,
  onClose,
  showCard,
  size,
  children,
  desktopWidth,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const isMobile = useMobile()

  return (
    <div
      ref={ref}
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100dvh",
        width: `min(${desktopWidth}, 100vw)`,
        position: "fixed",
        top: 0,
        pointerEvents: isOpen ? "auto" : "none",
        zIndex: "1000",
        overflow: "hidden",
        scrollbarWidth: "none",
      }}
    >
      <button
        style={{
          height: "100vh",
          width: "100vw",
          position: "absolute",
          cursor: "default",
        }}
        onClick={onClose}
      />
      <div
        style={{
          bottom: 0,
          background: "white",
          marginTop: "auto",
          position: "relative",
          marginBottom: isOpen && !isMobile ? "auto" : "unset",
          borderRadius: isMobile && size === "full-height" ? 0 : SPACING.space4,
          borderBottomLeftRadius: isMobile ? 0 : SPACING.space4,
          borderBottomRightRadius: isMobile ? 0 : SPACING.space4,
          width: "min(600px, 100%)",
          zIndex: "1000",
          transform: isOpen && showCard ? "translateY(0)" : "translateY(100vh)",
          transition: "transform 0.3s",
          height:
            isMobile && size === "default"
              ? "95vh"
              : size === "full-height"
                ? "100dvh"
                : "auto",
          overflow: "auto",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default SlideUpModalCard
